module.exports = __webpack_public_path__ + "img/1.4464f8d9.png";